import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ReactComponent as ComingSoon } from "./comingsoon.svg";

import Home from "./components/Home";
//import Games from './components/Games';
//import Users from './components/Users';

import Data from "./components/agents/Data";
import ExpandRow from "./components/ExpandRow";

import Profile from "./components/profiles/Profile";
import Profiles from "./components/profiles/Profiles";

import LineType from "./components/lineTypes/LineType";
import LineTypes from "./components/lineTypes/LineTypes";

import WagerLimit from "./components/wagerLimits/WagerLimit";
import WagerLimits from "./components/wagerLimits/WagerLimits";

import Player from "./components/players/Player";
import Players from "./components/players/Players";

import Leagues from "./components/common/Leagues";
import Events from "./components/events/events";

import Game from "./components/games/Game";
import Games from "./components/games/Games";

import User from "./components/users/User";
import Users from "./components/users/Users";

import InfiniteList from "./components/InfiniteList";

import WebConfigurator from "./components/WebConfigurator/WebConfigurator";

import LinesManager from "./containers/LinesManager";

import Agents from "./components/agents/Agents";
import Login from "./components/Login.js";

import BetTicker from "./components/betTicker/BetTicker";
import Reports from "./components/reports/ReportsMenu";

import { useRef } from "react";
import { UserContext } from "./contexts/UserContext";
/*Loader */

/*animation*/
import { ThemeProvider } from "@material-ui/core/styles";
import { theme } from "./styles/theme";

import { ToastContainer } from "react-toastify";

import DateFnsUtils from "@date-io/date-fns";
import {
  Button,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import "./App.css";
import { Command } from "./components/Command";
import AdjustmentTypes from "./components/common/crud/AdjustmentTypes";
import AgentPerHead from "./components/common/crud/AgentPerHead";
import AgentsOnline from "./components/common/crud/AgentsOnline";
import BonusExchangeRate from "./components/common/crud/BonusExchangeRate";
import Books from "./components/common/crud/Books";
import Currency from "./components/common/crud/Currency";
import UserDepartments from "./components/common/crud/Department";
import Derivatives from "./components/common/crud/Derivatives.js";
import FlagMessageType from "./components/common/crud/FlagMessageType";
import FreePlayOfficeOptions from "./components/common/crud/FreePlayOfficeOptions";
import GameColors from "./components/common/crud/GameColors";
import GameTypes from "./components/common/crud/GameTypes";
import Groups from "./components/common/crud/Groups";
import LeagueRegions from "./components/common/crud/LeagueRegions";
import MLBEasterLineConversion from "./components/common/crud/MLBEasterLineConversion";
import MLBWideLineConversion from "./components/common/crud/MLBWideLineConversion";
import OddsBySport from "./components/common/crud/OddsBySport.js";
import OddsConversion from "./components/common/crud/OddsConversion";
import OfficeOptions from "./components/common/crud/OfficeOptions";
import PaymentMethod from "./components/common/crud/PaymentMethod";
import Pitcher from "./components/common/crud/Pitcher";
import PlayerOffices from "./components/common/crud/PlayerOffices";
import PlayerRating from "./components/common/crud/PlayerRating";
import PlayersOnCall from "./components/common/crud/PlayersOnCall";
import PlayerSource from "./components/common/crud/PlayerSource";
import SystemProcessQueue from "./components/common/crud/SystemProcessQueue";
import Teams from "./components/common/crud/Teams";
import Timezone from "./components/common/crud/Timezone";
import UserProfile from "./components/common/crud/UserProfile.js";
import UsersOnline from "./components/common/crud/UsersOnline";
import VoidReason from "./components/common/crud/VoidReason.js";
import GlobalSettings from "./components/common/GlobalSettings";
import Loader from "./components/common/loader/Loader.js";
import BlackBookList from "./components/common/tools/BlackBookList.js";
import CallFinder from "./components/common/tools/CallFinder.js";
import DeleteWagers from "./components/common/tools/DeleteWagers.js";
import FixBalance from "./components/common/tools/FixBalance.js";
import AgentLinetypeHide from "./components/common/tools/AgentsLinetypesHide.js";
import PlayerVolume from "./components/common/tools/PlayerVolume.js";
import UngradedGames from "./components/common/tools/UngradedGames.js";
import WagerFinder from "./components/common/tools/WagerFinder.js";
import Horses from "./components/Horses/Horses.js";
import { Link } from "./components/Link";
import DeleteGameLines from "./components/specials/DeleteGameLines.js";
import BookSettings from "./components/systemPreferences/bookSettings/BookSettings.js";
import CallCenterSettings from "./components/systemPreferences/callCenterSettings/CallCenterSettings.js";
import SystemDefault from "./components/systemPreferences/systemDefaults/SystemDefaults.js";
import { useData } from "./contexts/DataContext.jsx";
import { useUserRights } from "./contexts/UserRightsContext.jsx";
import { getPreviousAndUpcomingSunday } from "./utils/date.js";
import PlayerModifyMassive from "./components/players/playerComponents/PlayerModifyMassive.js";
import MessagesInbox from "./components/messages/MessagesInbox.js";
import MessagesCompose from "./components/messages/MessagesCompose.js";
import MessagesConversation from "./components/messages/MessagesConversation.js";
import MessagesSent from "./components/messages/MessagesSent.js";
import MessagesLayout from "./components/messages/MessagesLayout.js";
import { MessageProvider, useMessages } from "./contexts/MessageContext.jsx";
import Badge from "@material-ui/core/Badge";
export default function App() {
  const [message, setMessage] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [scheduleVisible, setScheduleVisible] = useState(false);
  const [recentGame, setRecentGame] = useState({ idGame: 0, idLinetype: 0 });

  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const [compact, setCompact] = useState(() => {
    const saved = localStorage.getItem("compact-menu");
    return saved !== null ? JSON.parse(saved) : false;
  });
  // Update localStorage when myState changes
  useEffect(() => {
    localStorage.setItem("compact-menu", JSON.stringify(compact));
  }, [compact]);

  const logout = () => {
    axios({
      method: "post",
      url: process.env.REACT_APP_API2_URL + "/login/Logout",
      data: {
        IdUser: userInfo.userId,
      },
    }).then((response) => {
      if (response.status === 200) {
        localStorage.removeItem("userInfo");
        handleClose();
      }
    });
  };
  //subscribeToChanges((err, change) => console.log(change));
  const childRef = useRef();
  const historyRef = useRef();
  const setOnSchedule = (value) => {
    setScheduleVisible(value);
  };

  const getRecentGame = () => {
    return recentGame.idGame;
  };

  /*const socket = openSocket(process.env.REACT_APP_NOTIFICATION_SRV_URL);*/

  /*socket.on("anounceChange", function (msg) {
    //setRecentGame(msg);
    let currChildRef = childRef.current;
    var lastGame = JSON.parse(localStorage.getItem("lastGame"));
    if (msg.securityCode) {
      if (msg.message && msg.message != "") {
        setMessage((message) => [...message, msg.message]);
      } else {
        let filteredArray = message.filter(
          (item) => item.securityCode !== msg.securityCode
        );
        setMessage(filteredArray);
      }
    } else if (msg.idGame) {
      if (currChildRef) {
        childRef.current.searchGameValuesChild(msg);
      }
    }
    // socket.disconnect();
  });*/

  const showLoading = (value) => {
    setShowLoader(value);
    /**/
  };

  const [open, setOpen] = useState({
    system: false,
    agents: false,
    affiliates: false,
    players: false,
    tasks: false,
    reports: false,
    takeBets: false,
    tools: false,
    systemPrefences: false,
    profiles: false,
    agentsMaintenance: false,
    bonusPoints: false,
    playersConfiguration: false,
    windows: false,
    help: false,
  });

  const toggle = (item) => {
    if (compact) setCompact(false);
    if (
      item !== "reports" &&
      historyRef.current?.location.pathname === "/reports"
    ) {
      historyRef.current.push("/home");
    }
    setOpen((currentOpen) => {
      const isOpening = compact ? true : !currentOpen[item];
      if (!isOpening) {
        return { ...currentOpen, [item]: false };
      }
      const closedState = Object.keys(currentOpen).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});
      return { ...closedState, [item]: true };
    });
  };

  /**
   * CLOSE WEEK
   */
  const [loading, setLoading] = useState(false);
  const [openCloseWeek, setOpenCloseWeek] = useState(false);
  const handleCloseWeek = useCallback((state) => {
    setOpenCloseWeek(state);
  }, []);

  const { previousSunday, upcomingSunday } = useMemo(
    () => getPreviousAndUpcomingSunday(),
    []
  );

  const [startDate, setStartDate] = useState(upcomingSunday);
  const onStartDateChange = useCallback((date) => {
    setStartDate(date);
  }, []);

  const requestCloseWeek = useCallback(() => {
    setLoading(true);

    const url =
      process.env.REACT_APP_API2_URL +
      "/User/CloseWeek?dateWeek=" +
      startDate.toISOString().split("T")[0] +
      "&idUser=" +
      userInfo.userId;
    axios
      .post(url, {
        idUser: userInfo.userId,
        dateWeek: startDate.toISOString().split("T")[0],
      })
      .then((response) => response.data)
      .then((status) => {
        setLoading(false);
        setOpenCloseWeek(false);
        if (status === 0) {
          alert("Week closed successfully");
        } else if (status === 7) {
          alert("Error: Open games in week");
        } else if (status === 8) {
          alert("Error: Date before last distribution");
        } else if (status === -1) {
          alert("Nothing done");
        }
      })
      .catch((err) => {
        if (!axios.isCancel(err)) {
          console.error(err);
        }
      });
  }, [startDate, userInfo?.userId]);

  const { data: rights } = useUserRights();
  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  const {
    data: { fullscreen },
    changeData,
  } = useData(false);

  const toggleFullscreen = useCallback(
    () => changeData({ fullscreen: !fullscreen }),
    [fullscreen, changeData]
  );

  return (
    <MessageProvider userId={userInfo?.userId}>
    <div>
      <div
        className="absolute top-0 right-0 z-20 flex items-center justify-center w-5 h-5 text-gray-500 cursor-pointer hover:text-black"
        onClick={toggleFullscreen}
      >
        <i className={`fas ${fullscreen ? "fa-compress" : "fa-expand"}`} />
        <Command
          hidden
          onActivated={toggleFullscreen}
          command="ctrl + shift + F"
        ></Command>
      </div>

      <ToastContainer position="top-right" autoClose={5000} />
      <Dialog
        open={openCloseWeek}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Close Week</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <div className="flex flex-col items-center justify-center gap-4">
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  autoOk
                  disabled={loading}
                  label="Week to close:"
                  className="w-full"
                  size="small"
                  variant="inline"
                  inputVariant="outlined"
                  format="yyyy-MM-dd"
                  value={startDate}
                  onChange={onStartDateChange}
                  shouldDisableDate={(date) => {
                    // Disable all days except the last two Sundays
                    const lastSunday = new Date(
                      new Date().setDate(
                        new Date().getDate() - new Date().getDay()
                      )
                    );
                    return (
                      date.getDay() !== 0 ||
                      date < previousSunday ||
                      date > upcomingSunday
                    );
                  }}
                />
              </MuiPickersUtilsProvider>
              <span>Are you sure you want to close the week?</span>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="h-9"
            disabled={loading}
            onClick={() => handleCloseWeek(false)}
            color="secondary"
            variant="contained"
            autoFocus
          >
            Cancel
          </Button>
          <Button
            className="h-9"
            disabled={loading}
            onClick={requestCloseWeek}
            color="primary"
            variant="contained"
          >
            {loading ? <Loader height={32} /> : "Close Week"}
          </Button>
        </DialogActions>
      </Dialog>

      <BrowserRouter>
        <Route
          render={({ location, history }) => {
            historyRef.current = history;
            return (
              <UserContext.Provider value="Hellos">
                <ThemeProvider theme={theme}>
                  {console.log("userName")}
                  <div className="flex flex-row">
                    {location.pathname != "/login" && !fullscreen ? (
                      location.pathname != "/" ? (
                        <div
                          className={`flex flex-col h-screen col-span-3 !py-6 bg-menu backdrop-blur-2xl w-60 min-w-max relative transition-[width] duration-300 ease-in-out ${
                            compact ? "compact" : ""
                          }`}
                        >
                          <div
                            onClick={() => setCompact(!compact)}
                            className="absolute z-10 flex items-center justify-center p-1 border rounded-full cursor-pointer shadow-lg shadow-black/40 !border-white/10 bg-menu-contrast backdrop-blur-xl leading-0 -right-3 top-1/8 w-7 h-7 transition-all duration-200 hover:scale-110 hover:bg-icon/80"
                          >
                            <i
                              className={`fa-solid leading-3  text-center text-gray-400 font-semibold text-xs transition-transform duration-200 ${
                                compact ? "fa-chevron-right" : "fa-chevron-left"
                              }`}
                            ></i>
                          </div>
                          <div className="flex flex-col h-screen overflow-y-scroll bg-menu">
                            <div className="relative flex flex-col bg-menu !px-4">
                              <div className="flex items-center gap-2 px-1 mb-4">
                                <span className="w-2 h-2 rounded-full bg-icon shadow-[0_0_8px_2px] shadow-icon/60" />
                                <span className="text-sm font-bold tracking-wide text-white uppercase sidebar-title">
                                  Admin Portal
                                </span>
                              </div>
                              {/* LINES MANAGER */}
                              <Link
                                hidden={!hasRights(355)}
                                className="link"
                                to="/linesmanager"
                                title="Lines Manager"
                                target="_blank"
                              >
                                <i className="fa-solid fa-chart-line"></i>
                                <span>Lines Manager</span>
                                <i className="absolute w-auto fill-gray-400 right-2 fa-solid fa-square-arrow-up-right suffix" />
                              </Link>
                              <Link
                                hidden={!hasRights(350)}
                                className="link"
                                to="/betticker"
                                title="Bet Ticker"
                              >
                                <i className="fa-regular fa-clock"></i>
                                <span>Bet Ticker</span>
                              </Link>
                              <div className="menu-section">
                                <hr />
                                <h3 className="my-2 text-xs text-gray-400">
                                  Management
                                </h3>
                                <hr />
                              </div>
                              {/* SYSTEM MENU */}
                              <button
                                hidden={!hasRights(4, 3, 2, 516)}
                                className={`link ${
                                  open.system ? "active" : ""
                                }`}
                                title="Home"
                                onClick={() => toggle("system")}
                              >
                                <i className="fa-solid fa-computer"></i>
                                <span>System</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.system}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(4)}
                                  className="link"
                                  to="/AgentsOnline"
                                  title="Agents Online"
                                >
                                  <span>Agents Online</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(3)}
                                  className="link"
                                  to="/PlayersOnCall"
                                  title="Players On Call"
                                >
                                  <span>Players On Call</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(2)}
                                  className="link"
                                  to="/UsersOnline"
                                  title="Logged Users"
                                >
                                  <span>Logged Users</span>
                                </Link>
                                <hr />
                                <Link
                                  hidden={!hasRights(516)}
                                  className="link"
                                  to="/SystemProcessQueue"
                                  title="System Process Queue"
                                >
                                  <span>System Process Queue</span>
                                </Link>
                                <hr />
                                <Link
                                  className="link"
                                  onClick={logout}
                                  to="/logout"
                                  title="Exit"
                                >
                                  <span>Exit</span>
                                  <Command
                                    onActivated={logout}
                                    command="Alt + X"
                                  ></Command>
                                </Link>
                              </Collapse>
                              {/* AGENT MENU */}
                              <button
                                hidden={!hasRights(23)}
                                className={`link ${
                                  open.agents ? "active" : ""
                                }`}
                                title="Agents"
                                onClick={() => toggle("agents")}
                              >
                                <i className="fa-solid fa-people-group"></i>
                                <span>Agents</span>
                                <Command
                                  to="/data"
                                  command="Ctrl + A"
                                ></Command>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.agents}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(28)}
                                  className="link"
                                  to="/data"
                                  title="List"
                                  command="ctrl+a"
                                >
                                  <span>List</span>
                                  <Command
                                    to="/data"
                                    command="Ctrl + A"
                                  ></Command>
                                </Link>
                                {/*<hr />
                                <Link disabled>
                                  <span>Adjustments</span>
                                </Link>
                                <Link disabled>
                                  <span>Disbursements</span>
                                </Link>
                                <Link disabled>
                                  <span>Receipts</span>
                                </Link>
                                <Link disabled>
                                  <span>Transfers</span>
                                </Link>*/}
                              </Collapse>
                              {/* AFFILIATES */}
                              {/* <button
                                className={`link disabled ${
                                  open.affiliates ? "active" : ""
                                }`}
                                title="Affiliates"
                                onClick={() => toggle("affiliates")}
                              >
                                <i className="fa-solid fa-handshake"></i>
                                <span>Affiliates</span>
                                <ComingSoon className="absolute w-auto h-5 fill-gray-400 right-2" />
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.affiliates}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  className="link"
                                  to="/affiliates/list"
                                  title="List"
                                  disabled
                                >
                                  <span>List</span>
                                </Link>
                              </Collapse> */}
                              {/* Players */}
                              <button
                                hidden={!hasRights(29)}
                                className={`link ${
                                  open.players ? "active" : ""
                                }`}
                                title="Players"
                                onClick={() => toggle("players")}
                              >
                                <i className="fa-solid fa-person"></i>
                                <span>Players</span>
                                <Command
                                  to="/players"
                                  command="Ctrl + P"
                                ></Command>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.players}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(37)}
                                  className="link"
                                  to="/players"
                                  title="List"
                                >
                                  <span>List</span>
                                  <Command
                                    to="/players"
                                    command="Ctrl + P"
                                  ></Command>
                                </Link>
                              </Collapse>
                              {/* TASKS */}
                              <button
                                className={`link ${open.tasks ? "active" : ""}`}
                                title="Tasks"
                                onClick={() => toggle("tasks")}
                              >
                                <i className="fa-solid fa-tasks"></i>
                                <span>Tasks</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.tasks}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  className="link"
                                  onClick={() => handleCloseWeek(true)}
                                  title="Close Week"
                                >
                                  <span>Close Week</span>
                                  <Command
                                    onActivated={() => handleCloseWeek(true)}
                                    command="Ctrl + W"
                                  ></Command>
                                </Link>
                                <Link
                                  className="link"
                                  to="/tasks/process-agent-distributions"
                                  title="Process Agent Distributions"
                                  disabled
                                >
                                  <span>Process Agent Distributions</span>
                                </Link>
                                <Link
                                  className="link"
                                  to="/tasks/undo-agent-distributions"
                                  title="Undo Agent Distributions"
                                  disabled
                                >
                                  <span>Undo Agent Distributions</span>
                                </Link>
                                <Link
                                  className="link"
                                  to="/tasks/deactivate-unused-accounts"
                                  title="Deactivate Unused Accounts"
                                  disabled
                                >
                                  <span>Deactivate Unused Accounts</span>
                                </Link>
                                <Link
                                  className="link"
                                  to="/tasks/recalculate-bonus-points"
                                  title="Recalculate Bonus Points"
                                  disabled
                                >
                                  <span>Recalculate Bonus Points</span>
                                </Link>
                              </Collapse>
                              {/* REPORTS */}
                              <button
                                hidden={
                                  !hasRights(
                                    460, 511, 462, 489, 393, 463, 490, 464,
                                    465, 423, 509, 424, 425, 494, 426, 427,
                                    389, 390, 391, 392, 420, 410, 411, 412,
                                    413, 414, 415, 416, 417, 488, 440, 441,
                                    443, 444, 445, 446, 447, 448, 451, 453,
                                    456, 457, 428, 429, 430, 433, 542, 434,
                                    435, 436, 437, 438, 439
                                  )
                                }
                                className={`link ${
                                  open.reports ? "active" : ""
                                }`}
                                title="Reports"
                                onClick={() => toggle("reports")}
                              >
                                <i className="fa-solid fa-chart-pie"></i>
                                <span>Reports</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.reports}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={
                                    !hasRights(
                                      460, 511, 462, 489, 393, 463, 490, 464,
                                      465
                                    )
                                  }
                                  className="link"
                                  to="/reports?category=financial"
                                  title="Financial"
                                  isActive={(match, location) =>
                                    new URLSearchParams(location.search).get(
                                      "category"
                                    ) === "financial"
                                  }
                                >
                                  <i className="fa-solid fa-coins"></i>
                                  <span>Financial</span>
                                </Link>
                                <Link
                                  hidden={
                                    !hasRights(423, 509, 424, 425, 494, 426, 427)
                                  }
                                  className="link"
                                  to="/reports?category=players"
                                  title="Players"
                                  isActive={(match, location) =>
                                    new URLSearchParams(location.search).get(
                                      "category"
                                    ) === "players"
                                  }
                                >
                                  <i className="fa-solid fa-users"></i>
                                  <span>Players</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(389, 390, 391, 392)}
                                  className="link"
                                  to="/reports?category=agents"
                                  title="Agents"
                                  isActive={(match, location) =>
                                    new URLSearchParams(location.search).get(
                                      "category"
                                    ) === "agents"
                                  }
                                >
                                  <i className="fa-solid fa-user-tie"></i>
                                  <span>Agents</span>
                                </Link>
                                <Link
                                  hidden={
                                    !hasRights(
                                      420, 410, 411, 412, 413, 414, 415, 416,
                                      417, 488
                                    )
                                  }
                                  className="link"
                                  to="/reports?category=games"
                                  title="Games"
                                  isActive={(match, location) =>
                                    new URLSearchParams(location.search).get(
                                      "category"
                                    ) === "games"
                                  }
                                >
                                  <i className="fa-solid fa-dice-two"></i>
                                  <span>Games</span>
                                </Link>
                                <Link
                                  hidden={
                                    !hasRights(
                                      440, 441, 443, 444, 445, 446, 447, 448,
                                      451, 453, 456, 457
                                    )
                                  }
                                  className="link"
                                  to="/reports?category=wagers"
                                  title="Wagers"
                                  isActive={(match, location) =>
                                    new URLSearchParams(location.search).get(
                                      "category"
                                    ) === "wagers"
                                  }
                                >
                                  <i className="fa-solid fa-address-book"></i>
                                  <span>Wagers</span>
                                </Link>
                                <Link
                                  hidden={
                                    !hasRights(
                                      428, 429, 430, 433, 542, 434, 435, 436,
                                      437, 438, 439
                                    )
                                  }
                                  className="link"
                                  to="/reports?category=system"
                                  title="System"
                                  isActive={(match, location) =>
                                    new URLSearchParams(location.search).get(
                                      "category"
                                    ) === "system"
                                  }
                                >
                                  <i className="fa-solid fa-computer"></i>
                                  <span>System</span>
                                </Link>
                              </Collapse>
                              {/* TOOLS */}
                              <button
                                hidden={
                                  !hasRights(103, 115, 106, 575, 107, 318)
                                }
                                className={`link ${open.tools ? "active" : ""}`}
                                title="Tools"
                                onClick={() => toggle("tools")}
                              >
                                <i className="fa-solid fa-tools"></i>
                                <span>Tools</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.tools}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(103)}
                                  className="link"
                                  to="/tools/black-book-list"
                                  title="Black Book List"
                                >
                                  <span>Black Book List</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(115)}
                                  className="link"
                                  to="/tools/player-volume"
                                  title="Player Volume"
                                >
                                  <span>Player Volume</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(106)}
                                  className="link"
                                  to="/tools/wager-finder"
                                  title="Wager Finder"
                                >
                                  <span>Wager Finder</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(575)}
                                  className="link"
                                  to="/tools/delete-wagers"
                                  title="Delete Wagers"
                                >
                                  <span>Delete Wagers</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(107)}
                                  className="link"
                                  to="/tools/call-finder"
                                  title="Call Finder"
                                >
                                  <span>Call Finder</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(318)}
                                  className="link"
                                  to="/tools/system-error-log"
                                  title="System Error Log"
                                  disabled
                                >
                                  <span>System Error Log</span>
                                </Link>
                                <Link
                                  className="link"
                                  to="/tools/ungrade"
                                  title="Ungraded Gamed"
                                >
                                  <span>Ungrade</span>
                                </Link>
                                <Link
                                  className="link"
                                  to="/tools/fix-balance"
                                  title="Fix Balance Player"
                                  // disabled
                                >
                                  <span>Fix Balance</span>
                                </Link>
                                <Link
                                  hidden
                                  className="link"
                                  to="/tools/agents-linetypes-hide"
                                  title="Hide linetypes for agents"
                                // disabled
                                >
                                  <span>Hide LineTypes</span>
                                </Link>
                              </Collapse>

                              <div className="menu-section">
                                <hr />
                                <h3 className="my-2 text-xs text-gray-400">
                                  Maintenance
                                </h3>
                                <hr />
                              </div>

                              <button
                                title="Data Import"
                                onClick={() => toggle("dataImport")}
                                className={`link disabled ${
                                  open.dataImport ? "active" : ""
                                }`}
                              >
                                <i className="fa-solid fa-rotate"></i>
                                <span>Data Import</span>
                                <ComingSoon className="absolute w-auto h-5 fill-gray-400 right-2" />
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.dataImport}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  className="link"
                                  to="/import-horses"
                                  title="Books"
                                  disabled
                                >
                                  <span>Horses</span>
                                </Link>
                              </Collapse>

                              <button
                                hidden={!hasRights(49, 470, 68, 51, 62, 61)}
                                className={`link ${
                                  open.profiles ? "active" : ""
                                }`}
                                title="Profiles"
                                onClick={() => toggle("profiles")}
                              >
                                <i className="fa-solid fa-user-circle"></i>
                                <span>Profiles</span>
                                <Command
                                  to="/profiles"
                                  command=""
                                ></Command>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.profiles}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(49)}
                                  className="link"
                                  to="/profiles"
                                  title="Profiles"
                                >
                                  <span>Profiles</span>
                                  <Command
                                    to="/profiles"
                                    command=""
                                  ></Command>
                                </Link>

                                <Link
                                  hidden={!hasRights(470)}
                                  className="link"
                                  to="/wagerLimits"
                                  title="Limits Profiles"
                                >
                                  <span>Limits Profiles</span>
                                  <Command
                                    to="/wagerLimits"
                                    command="Ctrl + L"
                                  ></Command>
                                </Link>
                                <hr />

                                <Link
                                  hidden={!hasRights(68)}
                                  className="link"
                                  to="/gametypes"
                                  title="Game Types"
                                >
                                  <span>Game Types</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(51)}
                                  className="link"
                                  to="/lineTypes"
                                  title="Line Types"
                                >
                                  <span>Line Types</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(470)}
                                  className="link"
                                  to="/OddsBySport"
                                  title="Odds by sports"
                                >
                                  <span>Odds By Sports</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(62)}
                                  className="link"
                                  to="/MLBEasterLineConversion"
                                  title="MLB Eastern Line Conversion"
                                >
                                  <span>MLB Eastern Line Conversion</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(61)}
                                  className="link"
                                  to="/MLBWideLineConversion"
                                  title="MLB Wide Line Conversion"
                                >
                                  <span>MLB Wide Line Conversion</span>
                                </Link>
                              </Collapse>

                              <button
                                hidden={!hasRights(505)}
                                className={`link ${
                                  open.agentsMaintenance ? "active" : ""
                                }`}
                                title="Agents"
                                onClick={() => toggle("agentsMaintenance")}
                              >
                                <i className="fa-solid fa-user-tie"></i>
                                <span>Agents</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.agentsMaintenance}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(505)}
                                  className="link"
                                  to="/agentPerHead"
                                  title="Profiles"
                                >
                                  <span>Agent Per Head</span>
                                </Link>
                              </Collapse>

                              <button
                                className="link"
                                title="Bonus Points"
                                onClick={() => toggle("bonusPoints")}
                              >
                                <i className="fa-solid fa-hashtag"></i>
                                <span>Bonus Points</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.bonusPoints}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  className="link"
                                  to="/BonusExchangeRate"
                                  title="Exchange Rate"
                                >
                                  <span>Exchange Rate</span>
                                </Link>
                                <button
                                  hidden={!hasRights(72)}
                                  className="link"
                                  title="Global Settings"
                                  onClick={() => toggle("globalSettings")}
                                >
                                  <span>Global Settings</span>
                                </button>
                                <GlobalSettings show={open.globalSettings} />
                                <Link
                                  className="link"
                                  to="/OfficeOptions"
                                  title="Office Options"
                                >
                                  <span>Office Options</span>
                                </Link>
                              </Collapse>
                              <button
                                hidden={
                                  !hasRights(
                                    113,
                                    569,
                                    340,
                                    328,
                                    56,
                                    59,
                                    344,
                                    323,
                                    112,
                                    329
                                  )
                                }
                                className="link"
                                title="Games Configuration"
                                onClick={() => toggle("gameConfiguration")}
                              >
                                <i className="fa-solid fa-cog"></i>
                                <span>Games Configuration</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.gameConfiguration}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(113)}
                                  className="link"
                                  to="/books"
                                  title="Books"
                                >
                                  <span>Books</span>
                                </Link>
                                <Link
                                  // hidden={!hasRights(569)}
                                  className="link"
                                  to="/game-configuration/derivatives"
                                  title="Derivatives"
                                >
                                  <span>Derivatives</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(340)}
                                  className="link"
                                  to="/events"
                                  title="Events"
                                >
                                  <span>Events</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(328)}
                                  className="link"
                                  to="/freePlayOfficeOptions"
                                  title="Free Play Office Options"
                                >
                                  <span>Free Play Office Options</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(56)}
                                  className="link"
                                  to="/gameColors"
                                  title="Game Colors"
                                >
                                  <span>Game Colors</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(59)}
                                  className="link"
                                  to="/leagues"
                                  title="Leagues"
                                >
                                  <span>Leagues</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(344)}
                                  className="link"
                                  to="/leagueRegions"
                                  title="League Regions"
                                >
                                  <span>League Regions</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(323)}
                                  className="link"
                                  to="/oddsConversion"
                                  title="Odds Conversion"
                                >
                                  <span>Odds Conversion</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(319)}
                                  className="link"
                                  to="/pitcher"
                                  title="Pitchers"
                                >
                                  <span>Pitchers</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(112)}
                                  className="link"
                                  to="/teams"
                                  title="Teams"
                                >
                                  <span>Teams</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(329)}
                                  className="link"
                                  to="/webConfigurator"
                                  title="Web Configurator"
                                >
                                  <span>Web Configurator</span>
                                </Link>
                              </Collapse>

                              <button
                                hidden={
                                  !hasRights(
                                    345,
                                    64,
                                    66,
                                    53,
                                    54,
                                    50,
                                    67,
                                    55,
                                    279,
                                    338
                                  )
                                }
                                className="link"
                                title="Players Configuration"
                                onClick={() => toggle("playersConfiguration")}
                              >
                                <i className="fa-solid fa-tools"></i>
                                <span>Players Configuration</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.playersConfiguration}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(345)}
                                  className="link"
                                  to="/adjustmentTypes"
                                  title="Adjustment Types"
                                >
                                  <span>Adjustment Types</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(64)}
                                  className="link"
                                  to="/currency"
                                  title="Currency"
                                >
                                  <span>Currency</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(66)}
                                  className="link"
                                  to="/flagMessageType"
                                  title="Flag Message Type"
                                >
                                  <span>Flag Message Type</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(53)}
                                  className="link"
                                  to="/groups"
                                  title="Groups"
                                >
                                  <span>Groups</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(54)}
                                  className="link"
                                  to="/paymentMethod"
                                  title="Payment Methods"
                                >
                                  <span>Payment Methods</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(50)}
                                  className="link"
                                  to="/playerOffices"
                                  title="Player Offices"
                                >
                                  <span>Player Offices</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(67)}
                                  className="link"
                                  to="/playerRating"
                                  title="Player Rating"
                                >
                                  <span>Player Rating</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(55)}
                                  className="link"
                                  to="/playerSource"
                                  title="Player Sources"
                                >
                                  <span>Player Sources</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(279)}
                                  className="link"
                                  to="/player-sources-by-book"
                                  title="Player Sources By Book"
                                  disabled
                                >
                                  <span>Player Sources By Book</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(338)}
                                  className="link"
                                  to="/timezone"
                                  title="Time Zone"
                                >
                                  <span>Time Zone</span>
                                </Link>
                              </Collapse>

                              {/* SYSTEM PREFERENCES */}
                              <button
                                className={`link ${
                                  open.systemPrefences ? "active" : ""
                                }`}
                                title="System Preferences"
                                onClick={() => toggle("systemPrefences")}
                              >
                                <i className="fa-solid fa-computer"></i>
                                <span>System Preferences</span>
                              </button>

                              <Collapse
                                className="collapsable"
                                in={open.systemPrefences}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(334)}
                                  disabled
                                  className="link"
                                  to="/bookSettings"
                                  title="Book Settings"
                                >
                                  <span>Book Settings</span>
                                </Link>
                                <Link
                                  disabled
                                  className="link"
                                  to="/callCenterSettings"
                                  title="Call Center Settings"
                                >
                                  <span>Call Center Settings</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(122)}
                                  disabled
                                  className="link"
                                  to="/systemDefaults"
                                  title="System Defaults"
                                >
                                  <span>System Defaults</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(499)}
                                  disabled
                                  className="link"
                                  to="/systemServicesRegistration"
                                  title="System Services Registration"
                                >
                                  <span>System Services Registration</span>
                                </Link>
                                <Link
                                  disabled
                                  className="link"
                                  to="/systemSettings"
                                  title="System Settings"
                                >
                                  <span>System Settings</span>
                                </Link>
                                <Link
                                  hidden={!hasRights(517)}
                                  disabled
                                  className="link"
                                  to="/accountTracking"
                                  title="Account Tracking"
                                >
                                  <span>Account Tracking</span>
                                </Link>
                              </Collapse>

                              <button
                                className="link"
                                title="Users Configuration"
                                onClick={() => toggle("usersConfiguration")}
                              >
                                <i className="fa-solid fa-users-cog"></i>
                                <span>Users Configuration</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.usersConfiguration}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  hidden={!hasRights(69)}
                                  className="link"
                                  to="/users"
                                  title="List"
                                >
                                  <span>List</span>
                                </Link>
                                <hr />
                                <Link
                                  hidden={!hasRights(73)}
                                  className="link"
                                  to="/users-configuration/user-profiles-info"
                                  title="User Profiles Info"
                                >
                                  <span>User Profiles</span>
                                </Link>
                                <hr />
                                <Link
                                  hidden={!hasRights(468)}
                                  className="link"
                                  to="/UserDepartments"
                                  title="User Departments"
                                >
                                  <span>User Departments</span>
                                </Link>
                              </Collapse>
                              <button
                                className={`link ${
                                  open.specials ? "active" : ""
                                }`}
                                title="Specials"
                                onClick={() => toggle("specials")}
                              >
                                <i className="fa-solid fa-user-circle"></i>
                                <span>Specials</span>
                              </button>
                              <Collapse
                                className="collapsable"
                                in={open.specials}
                                timeout="auto"
                                unmountOnExit
                              >
                                <Link
                                  className="link"
                                  to="/deletelines"
                                  title="QrGenerator"
                                >
                                  <span>Delete Lines Log</span>
                                </Link>
                              </Collapse>
                              <Link
                                className="link"
                                to="/void-reason"
                                title="Void Reason"
                              >
                                <i className="fa-solid fa-times-circle"></i>
                                <span>Void Reason</span>
                              </Link>

                              <MessagesMenuLink userId={userInfo?.userId} />

                              <div className="sticky bottom-0 bg-menu">
                                <hr />
                                <Link
                                  className="link"
                                  onClick={logout}
                                  to="/"
                                  exact
                                  title="Logout"
                                >
                                  <i className="fa-solid fa-power-off"></i>
                                  <span>Logout</span>
                                  <Command
                                    onActivated={logout}
                                    command="Ctrl + X"
                                  ></Command>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )
                    ) : (
                      ""
                    )}
                    <div
                      className={`flex-1 h-screen overflow-y-scroll flex flex-row gap-4 ${
                        location.pathname !== "/reports" && !location.pathname.startsWith("/messages") ? "p-4" : ""
                      }`}
                    >
                      <Switch>
                        <Route path="/login">
                          <Login />
                        </Route>
                        <Route path="/users">
                          <Users setOnSchedule={setOnSchedule} />
                        </Route>

                        <Route path="/games">
                          <Games setOnSchedule={setOnSchedule} />
                        </Route>

                        <Route path="/game-configuration/derivatives">
                          <Derivatives />
                        </Route>
                        <Route path="/void-reason">
                          <VoidReason />
                        </Route>
                        <Route path="/users-configuration/user-profiles-info">
                          <UserProfile />
                        </Route>
                        <Route path="/tools/black-book-list">
                          <BlackBookList />
                        </Route>
                        <Route path="/tools/call-finder">
                          <CallFinder />
                        </Route>
                        <Route path="/tools/delete-wagers">
                          <DeleteWagers />
                        </Route>
                        <Route path="/tools/wager-finder">
                          <WagerFinder />
                        </Route>
                        <Route path="/tools/player-volume">
                          <PlayerVolume />
                        </Route>
                        <Route path="/tools/ungrade">
                          <UngradedGames />
                        </Route>
                        <Route path="/tools/fix-balance">
                          <FixBalance />
                        </Route>
                        <Route path="/tools/agents-linetypes-hide">
                          <AgentLinetypeHide />
                        </Route>
                        <Route path="/OddsBySport">
                          <OddsBySport />
                        </Route>
                        <Route path="/OfficeOptions">
                          <OfficeOptions />
                        </Route>
                        <Route path="/PlayersOnCall">
                          <PlayersOnCall />
                        </Route>
                        <Route path="/SystemProcessQueue">
                          <SystemProcessQueue />
                        </Route>
                        <Route path="/UsersOnline">
                          <UsersOnline />
                        </Route>
                        <Route path="/AgentsOnline">
                          <AgentsOnline />
                        </Route>
                        <Route path="/UserDepartments">
                          <UserDepartments />
                        </Route>
                        <Route path="/BonusExchangeRate">
                          <BonusExchangeRate />
                        </Route>
                        <Route path="/MLBWideLineConversion">
                          <MLBWideLineConversion />
                        </Route>
                        <Route path="/MLBEasterLineConversion">
                          <MLBEasterLineConversion />
                        </Route>
                        <Route path="/groups">
                          <Groups />
                        </Route>
                        <Route path="/timezone">
                          <Timezone />
                        </Route>
                        <Route path="/playerSource">
                          <PlayerSource />
                        </Route>
                        <Route path="/playerRating">
                          <PlayerRating />
                        </Route>
                        <Route path="/playerOffices">
                          <PlayerOffices />
                        </Route>
                        <Route path="/paymentMethod">
                          <PaymentMethod />
                        </Route>
                        <Route path="/flagMessageType">
                          <FlagMessageType />
                        </Route>
                        <Route path="/currency">
                          <Currency />
                        </Route>
                        <Route path="/adjustmentTypes">
                          <AdjustmentTypes />
                        </Route>
                        <Route path="/import-horses">
                          <Horses />
                        </Route>
                        <Route path="/deletelines">
                          <DeleteGameLines />
                        </Route>
                        <Route path="/books">
                          <Books />
                        </Route>
                        <Route path="/freePlayOfficeOptions">
                          <FreePlayOfficeOptions />
                        </Route>
                        <Route path="/teams">
                          <Teams />
                        </Route>
                        <Route path="/pitcher">
                          <Pitcher />
                        </Route>
                        <Route path="/oddsConversion">
                          <OddsConversion />
                        </Route>
                        <Route path="/leagueRegions">
                          <LeagueRegions />
                        </Route>
                        <Route path="/gameColors">
                          <GameColors />
                        </Route>
                        <Route path="/agentPerHead">
                          <AgentPerHead />
                        </Route>
                        <Route path="/agentPerHead">
                          <AgentPerHead />
                        </Route>
                        <Route path="/gametypes">
                          <GameTypes />
                        </Route>
                        <Route path="/betticker">
                          <BetTicker isInput={false} message={message} />
                        </Route>

                        <Route path="/leagues">
                          <Leagues showDataTable={true} />
                        </Route>

                        <Route path="/events">
                          <Events showDataTable={true} />
                        </Route>

                        <Route path="/linesmanager">
                          <LinesManager
                            getRecentGame={getRecentGame}
                            setRecentGame={setRecentGame}
                            //announce={announce}
                            ref={childRef}
                          />
                        </Route>

                        <Route path="/agents">
                          <Agents
                            setOnSchedule={setOnSchedule}
                            ref={childRef}
                          />
                        </Route>

                        <Route path="/expandRow">
                          <ExpandRow ref={childRef} />
                        </Route>
                        <Route path="/data">
                          <Data setOnSchedule={setOnSchedule} ref={childRef} />
                        </Route>
                        <Route path="/InfiniteList">
                          <InfiniteList ref={childRef} />
                        </Route>
                        <Route path="/agentContainer/:id" component={Agents} />
                        <Route path="/updatePlayers" component={PlayerModifyMassive} />
                        <Route
                          path="/profile/:id"
                          component={Profile}
                          showLoading={showLoading}
                        />
                        <Route path="/profiles">
                          <Profiles
                            setOnSchedule={setOnSchedule}
                            ref={childRef}
                            showLoading={showLoading}
                          />
                        </Route>

                        <Route path="/users">
                          <Users
                            setOnSchedule={setOnSchedule}
                            ref={childRef}
                            showLoading={showLoading}
                          />
                        </Route>
                        <Route
                          path="/user/:id"
                          component={User}
                          showLoading={showLoading}
                        />

                        <Route path="/webConfigurator">
                          <WebConfigurator showLoading={showLoading} />
                        </Route>

                        <Route
                          path="/wagerLimit/:id"
                          component={WagerLimit}
                          showLoading={showLoading}
                        />
                        <Route path="/wagerLimits">
                          <WagerLimits
                            setOnSchedule={setOnSchedule}
                            ref={childRef}
                            showLoading={showLoading}
                          />
                        </Route>

                        <Route
                          path="/lineType/:id"
                          component={LineType}
                          showLoading={showLoading}
                        />
                        <Route path="/lineTypes">
                          <LineTypes
                            setOnSchedule={setOnSchedule}
                            ref={childRef}
                            showLoading={showLoading}
                          />
                        </Route>

                        <Route
                          path="/player/:id"
                          component={Player}
                          showLoading={showLoading}
                        />

                        <Route path="/players">
                          <Players
                            setOnSchedule={setOnSchedule}
                            ref={childRef}
                            showLoading={showLoading}
                          />
                        </Route>
                        <Route
                          path="/game/:id"
                          component={Game}
                          showLoading={showLoading}
                        />

                        <Route path="/games">
                          <Games
                            setOnSchedule={setOnSchedule}
                            ref={childRef}
                            showLoading={showLoading}
                          />
                        </Route>

                        <Route path="/reports">
                          <Reports
                            setOnSchedule={setOnSchedule}
                            ref={childRef}
                            showLoading={showLoading}
                          />
                        </Route>

                        <Route path="/bookSettings">
                          <BookSettings />
                        </Route>

                        <Route path="/callCenterSettings">
                          <CallCenterSettings />
                        </Route>

                        <Route path="/systemDefaults">
                          <SystemDefault />
                        </Route>

                        <Route path="/home">
                          <Home setOnSchedule={setOnSchedule} />
                        </Route>
                        {/*<Route path="/">
                      <Login />
                </Route>*/}

                        <Route path="/messages/conversation/:otherUserId">
                          <MessagesLayout>
                            <MessagesConversation userId={userInfo?.userId} />
                          </MessagesLayout>
                        </Route>
                        <Route path="/messages/compose">
                          <MessagesLayout>
                            <MessagesCompose userId={userInfo?.userId} />
                          </MessagesLayout>
                        </Route>
                        <Route path="/messages/inbox">
                          <MessagesLayout>
                            <MessagesInbox userId={userInfo?.userId} />
                          </MessagesLayout>
                        </Route>
                        <Route path="/messages/sent">
                          <MessagesLayout>
                            <MessagesSent userId={userInfo?.userId} />
                          </MessagesLayout>
                        </Route>
                        <Route path="/messages">
                          <MessagesLayout>
                            <MessagesInbox userId={userInfo?.userId} />
                          </MessagesLayout>
                        </Route>

                        <Route path="/">
                          <Login />
                        </Route>
                      </Switch>
                    </div>
                  </div>
                </ThemeProvider>
              </UserContext.Provider>
            );
          }}
        />
      </BrowserRouter>
    </div>
    </MessageProvider>
  );
}

function MessagesMenuLink({ userId }) {
  const { unreadCount } = useMessages();
  return (
    <Link hidden className="link" to="/messages" title="Messages">
      <Badge badgeContent={unreadCount || 0} color="error" max={99}>
        <i className="fa-solid fa-envelope"></i>
      </Badge>
      <span>Messages</span>
    </Link>
  );
}
